export function createRequestDeduper<K, V>(options?: { retainSuccess?: boolean }) {
  const pending = new Map<K, Promise<V>>()

  return {
    run(key: K, task: () => Promise<V>) {
      const existing = pending.get(key)
      if (existing) return existing
      const request = task()
      pending.set(key, request)
      void request.then(
        () => {
          if (!options?.retainSuccess && pending.get(key) === request) pending.delete(key)
        },
        () => {
          if (pending.get(key) === request) pending.delete(key)
        },
      )
      return request
    },
    get(key: K) {
      return pending.get(key)
    },
    has(key: K) {
      return pending.has(key)
    },
    delete(key: K) {
      return pending.delete(key)
    },
    clear() {
      pending.clear()
    },
    keys() {
      return pending.keys()
    },
    size() {
      return pending.size
    },
  }
}
